import { useQuery } from "@tanstack/react-query";
import { REFRESH_INTERVAL } from "../models/constants";
import { getStandsData } from "../repositories/MillSetupRepository";

export const useStandsData = () => {
	return useQuery({
		queryKey: ["millSetup", "stands"],
		queryFn: ({ signal }) => getStandsData(signal),
		refetchInterval: REFRESH_INTERVAL,
		staleTime: REFRESH_INTERVAL - 1000,
		retry: false,
		refetchOnWindowFocus: false,
	});
};
